import { useAskDeepResearchSelection } from '#pplx/frontend/apps/ask/hooks/ask-deep-research-hooks/useAskDeepResearchSelection.js';
import { useGateSearchModelSelection } from '#pplx/frontend/apps/ask/hooks/search-model-selection-hooks/useGateSearchModelSelection.js';
import { useThreadConfig } from '#pplx/frontend/apps/ask/providers/ThreadSettingsProviderShared.js';
import { useDefaultSearchModel } from '#pplx/frontend/apps/ask/search/hooks/useDefaultSearchModel.js';
import { useSearchModeForSearchModel } from '#pplx/frontend/apps/ask/search/hooks/useSearchModeForSearchModel.js';
import { usePreferredSearchModels } from '#pplx/frontend/apps/ask/settings/hooks/usePreferredSearchModels.js';
import { SearchModel } from '#pplx/frontend/ask-models/types/search-modes.js';
import { useCallback } from 'react';
/**
 * Sets the user's preferred search model. The search mode is automatically
 * derived from the model (e.g. 'gpt4.5' maps to 'Pro' search mode).
 */
export function useSelectSearchModel({ openPaywallUpsell, }) {
    const { setPreferredSearchModel } = usePreferredSearchModels();
    const { setConfiguredModel } = useThreadConfig();
    const getSearchModeForSearchModel = useSearchModeForSearchModel();
    const { gateSearchModelSelection } = useGateSearchModelSelection({
        openPaywallUpsell,
    });
    const defaultSearchModel = useDefaultSearchModel();
    const { getComputerModel, apply: applyDeepResearchSelection, clear: clearDeepResearchSelection, } = useAskDeepResearchSelection();
    return useCallback((searchModel = defaultSearchModel) => {
        const computerModel = getComputerModel(searchModel);
        const isGated = gateSearchModelSelection(computerModel ?? searchModel);
        if (isGated) {
            return false;
        }
        const searchMode = getSearchModeForSearchModel(searchModel);
        if (!import.meta.env.VITE_IS_SIDECAR_BUILD) {
            setPreferredSearchModel(searchMode, searchModel);
        }
        if (computerModel) {
            applyDeepResearchSelection(searchModel, computerModel);
        }
        else {
            clearDeepResearchSelection(searchModel);
        }
        setConfiguredModel(computerModel ?? searchModel);
        return true;
    }, [
        gateSearchModelSelection,
        defaultSearchModel,
        setPreferredSearchModel,
        setConfiguredModel,
        getSearchModeForSearchModel,
        getComputerModel,
        applyDeepResearchSelection,
        clearDeepResearchSelection,
    ]);
}
//# sourceMappingURL=useSelectSearchModel.js.map